import React from "react";
import { Text, Image } from "react-native";
import { View } from "react-native";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppColors } from "../../utility/AppColors";
import ImageComponent from "../ImageComponent";
import { AppImages } from "../../utility/AppImages";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import Separator from "../Separator";
import PastEventDetailSkeleton from "../skeleton-components/PastEventDetailSkeleton";
import { TouchableOpacity } from "react-native-gesture-handler";
import { CropImage } from "../choose-avatar-components/CropImage";
import Avatar from "../choose-avatar-components/Avatar";
import StarRating from "./StarRating";

const EventDetailComponent = ({
  styles,
  showLoader,
  eventData,
  setIsShare,
}) => {
  const deviceSize = useDeviceSize();
  const totalViewers = eventData?.event?.attendeeIDs?.length || 0;
  const totalGiftedTokens = eventData?.totalTokens || 0;
  const totalLikes = eventData?.likeCount || 0;

  const formatLikes = (count) => {
    if (count >= 1000) {
      return `${(count / 1000).toFixed(1).replace(/\.0$/, "")}K`;
    }
    return count.toString();
  };

  return showLoader ? (
    <PastEventDetailSkeleton styles={styles} />
  ) : (
    <View
      style={{
        flexDirection: "row",
        padding: 12,
        justifyContent: "space-between",
        alignItems: "center",
        borderRadius: 8,
        borderWidth: 0.8,
        borderColor: "#374151",
        marginVertical: 15,
      }}
    >
      {/* Left Side - Stats */}
      <View style={{ flexDirection: "row", gap: 24, alignItems: "center" }}>
        {/* Total Viewers */}
        <View style={{ flexDirection: "column", gap: 8 }}>
          <View style={{ flexDirection: "row", alignItems: "center", gap: 8 }}>
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_14,
                { color: AppColors.white },
              ]}
            >
              Total Viewers:
            </Text>
            <Text
              style={[
                AppFontStyle.BOLD_ANYBODY_14,
                { color: AppColors.white },
              ]}
            >
              {totalViewers}
            </Text>
          </View>
          <View
            style={{
              height: 40,
              width: 135,
              position: "relative",
            }}
          >
            {eventData?.attendeeProfiles?.length > 0 ? (
              eventData?.attendeeProfiles
                .slice(0, 5)
                .map((details: any, index: number) =>
                  details.profilePicture ? (
                    <View
                      key={index}
                      style={{
                        height: 32,
                        width: 32,
                        backgroundColor: AppColors.lightPurple_604e74,
                        borderRadius: 32,
                        overflow: "hidden",
                        position: "absolute",
                        left: index * 20,
                      }}
                    >
                      <Avatar
                        src={details.profilePicture}
                        variant="pastSmallPlayer"
                      />
                    </View>
                  ) : (
                    <View
                      key={index}
                      style={{
                        height: 32,
                        width: 32,
                        borderRadius: 32,
                        backgroundColor: AppColors.lightPurple_604e74,
                        position: "absolute",
                        left: index * 20,
                      }}
                    />
                  )
                )
            ) : null}
          </View>
        </View>

        {/* Total Gifts in Tokens */}
        <View style={{ flexDirection: "column", gap: 8 }}>
          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_14,
              { color: AppColors.white },
            ]}
          >
            Total Gifts in Tokens
          </Text>
          <View style={{ flexDirection: "row", alignItems: "center", gap: 8 }}>
            <ImageComponent
              url={AppImages.icGiftEvent}
              style={{
                resizeMode: "contain",
                width: 30,
                height: 30,
              }}
            />
            <Text
              style={[
                AppFontStyle.BOLD_ANYBODY_16,
                { color: AppColors.white },
              ]}
            >
              {totalGiftedTokens} Tokens
            </Text>
          </View>
        </View>

        {/* Total Likes */}
        <View style={{ flexDirection: "column", gap: 8 }}>
          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_14,
              { color: AppColors.white },
            ]}
          >
            Total Likes
          </Text>
          <View style={{ flexDirection: "row", alignItems: "center", gap: 8 }}>
            <ImageComponent
              url={AppImages.icLikeEvent}
              style={{
                resizeMode: "contain",
                width: 30,
                height: 30,
              }}
            />
            <Text
              style={[
                AppFontStyle.BOLD_ANYBODY_16,
                { color: AppColors.white },
              ]}
            >
              {formatLikes(totalLikes)}
            </Text>
          </View>
        </View>
      </View>

      {/* Right Side - Feedback */}
      <View style={{ flexDirection: "row", alignItems: "center", gap: 24 }}>
        <View>
          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_14,
              { color: AppColors.white, marginBottom: 8 },
            ]}
          >
            Nice stream! How'd it feel?
          </Text>
          <StarRating rating={4} totalStars={5} size={38} />
        </View>

        <TouchableOpacity
          style={{
            backgroundColor: "#DC2626",
            borderRadius: 8,
            paddingVertical: 16,
            paddingHorizontal: 24,
          }}
          onPress={() => {
            // Open WhatsApp link in new tab
            window.open('https://chat.whatsapp.com/J6ntLXPLDpYAeSmSQ7AgTG?mode=wwt', '_blank');
          }}
        >
          <Text
            style={[
              AppFontStyle.BOLD_ANYBODY_16,
              { color: AppColors.white },
            ]}
          >
            Give us Feedback
          </Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

export default EventDetailComponent;
